import axios from 'axios';

const accountActivation = (data) => (
  axios.post(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/auth/activation`,
    data,
  ));

export default accountActivation;
